<template>
  <div>
    <div>
      <loader v-if="loading"></loader>
    </div>

    <div v-if="!loading">
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <b-card class="full-width">
        <div slot="header" class="mt-0">
          <b-row align-v="center">
            <b-col md="6">
              <strong class="view-header-class">
                {{
                  partnerAllData &&
                  partnerAllData.authentication &&
                  partnerAllData.authentication.userName
                }}
                - View
              </strong>
            </b-col>
            <b-col>
              <b-row align-h="end" align-v="center">
                <b-col md="5">
                  <b-form-group label-cols-sm="3" class="mb-0">
                    <label>Status</label>
                    <eb-select
                      type="select"
                      label="text"
                      id="userStatus"
                      v-model="selectedStatus"
                      :options="['ACTIVE', 'INACTIVE', 'CANCELLED']"
                      :selected="selectedStatus"
                      @input="changeStatus"
                    ></eb-select>
                  </b-form-group>
                </b-col>
                <div
                  v-if="
                    partnerAllData.category === 'SELLER' ||
                    partnerAllData.category === 'OFFICE'
                  "
                >
                  <p class="m-0 p-0 mr-2 mt-2" style="font-size: 14px">
                    {{ !partnerAllData.isOffline ? " Online" : " Offline" }}
                  </p>
                  <c-switch
                    @change="offlinePartner"
                    v-model="partnerAllData.isOffline"
                    :inverse="true"
                    color="primary"
                    class="mx-2 mr-3 mt-2 mb-3"
                    variant="pill"
                  ></c-switch>
                </div>
                <strong
                  class="mr-1 mt-2 btn btn-danger"
                  @click="deletepartner(partnerAllData)"
                  >Delete</strong
                >
                <router-link
                  :to="partnerRoute"
                  class="mt-2"
                  style="color: white; text-decoration: none"
                >
                  <strong class="mr-1 btn btn-primary">Back</strong>
                </router-link>
              </b-row>
            </b-col>
          </b-row>
        </div>

        <b-row>
          <b-col md="6">
            <div class="accordion faq-section" role="tablist">
              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-0" role="tab">
                  <b-button
                    block
                    v-b-toggle.accordion-1
                    variant="light"
                    class="collapse-btn"
                    style="height: 71px; padding-top: 2px; padding-bottom: 0px"
                  >
                    <p style="margin-bottom: 0px">Organization</p>
                    <p style="font-size: 15px; color: black; display: inline">
                      Name : {{ partnerAllData.organization.name }}
                    </p>
                    <p
                      style="
                        font-size: 15px;
                        color: black;
                        display: inline;
                        float: right;
                        margin-right: 50px;
                      "
                    >
                      Merchant No : {{ partnerAllData.businessNo }}
                    </p>
                  </b-button>
                </b-card-header>
                <b-collapse id="accordion-1" role="tabpanel">
                  <b-card-body>
                    <org-view :orgoData="partnerAllData"></org-view>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </b-col>
          <b-col md="6">
            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button
                  block
                  v-b-toggle.accordion-2
                  variant="light"
                  class="collapse-btn"
                  style="height: 71px; padding-top: 2px; padding-bottom: 0px"
                  >Bill To
                  <p style="font-size: 15px; color: black">
                    Address : {{ partnerAllData.office.address.street1 }}
                    {{ partnerAllData.office.address.city }},
                    {{ partnerAllData.office.address.state }}
                    {{ partnerAllData.office.address.country }} ,
                    {{ partnerAllData.office.address.zip }}
                  </p>
                </b-button>
              </b-card-header>
              <b-collapse id="accordion-2" role="tabpanel">
                <b-card-body>
                  <bill-view :billData="partnerAllData"></bill-view>
                </b-card-body>
              </b-collapse>
            </b-card>
          </b-col>
          <!-- /////////////////////////////////////////// -->
        </b-row>
        <hr
          style="
            width: 1100px;
            height: 0px;
            left: 241px;
            top: 465px;
            border: 1px solid #efefef;
          "
        />
        <b-row>
          <b-col md="6">
            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button
                  block
                  v-b-toggle.accordion-3
                  variant="light"
                  class="collapse-btn"
                  style="height: 71px; padding-top: 2px; padding-bottom: 0px"
                  >Agreement
                  <div style="font-size: 15px; color: black">
                    <p>Category Type : {{ categoryTypeData }}</p>
                  </div>
                </b-button>
              </b-card-header>
              <b-collapse id="accordion-3" role="tabpanel">
                <b-card-body>
                  <agreement-view
                    :catalogDomainData="catalogDomainList"
                    :agreeData="partnerAllData.agreement"
                  ></agreement-view>
                </b-card-body>
              </b-collapse>
            </b-card>
          </b-col>
          <b-col md="6">
            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button
                  block
                  v-b-toggle.accordion-4
                  variant="light"
                  class="collapse-btn"
                  style="height: 71px; padding-top: 2px; padding-bottom: 0px"
                  >Credential
                  <p style="font-size: 15px; color: black">
                    Phone : {{ partnerAllData.authentication.phone }}
                  </p>
                  <p style="font-size: 15px; color: black; margin-top: -16px">
                    Email : {{ partnerAllData.authentication.email }}
                  </p>
                </b-button>
              </b-card-header>
              <b-collapse id="accordion-4" role="tabpanel">
                <b-card-body>
                  <credential-view
                    :authData="partnerAllData.authentication"
                  ></credential-view>
                </b-card-body>
              </b-collapse>
            </b-card>
          </b-col>
        </b-row>
      </b-card>
      <b-card style="">
        <b-row class="mx-1">
          <b-col>
            <router-link
              :to="{
                name: 'view-subscription',
                params: {
                  id: partnerAllData._id,
                  parentId: partnerAllData.officeHierarchy,
                },
              }"
            >
              <card-view
                class="subscription"
                cardName="Subscription"
              ></card-view>
            </router-link>
          </b-col>
          <b-col>
            <router-link
              :to="{
                name: 'Payment Info',
                params: {
                  id: partnerAllData._id,
                  parentId: partnerAllData.officeHierarchy,
                },
              }"
            >
              <card-view class="subscription" cardName="Payment"></card-view>
            </router-link>
          </b-col>
          <b-col>
            <router-link
              :to="{
                name: 'ChildPartnerList',
                params: {
                  id: partnerAllData._id,
                  parentId: partnerAllData.officeHierarchy,
                },
              }"
            >
              <card-view
                class="subscription"
                cardName="My Partners"
              ></card-view>
            </router-link>
          </b-col>
        </b-row>

        <b-row class="mx-1">
          <b-col>
            <router-link
              :to="{
                name: 'Manage-Orders',
                params: {
                  id: partnerAllData._id,
                  parentId: partnerAllData.officeHierarchy,
                },
              }"
            >
              <card-view class="subscription" cardName="Orders"></card-view>
            </router-link>
          </b-col>
          <b-col>
            <router-link
              :to="{
                name: 'View Invoice',
                params: {
                  id: partnerAllData._id,
                  parentId: partnerAllData.officeHierarchy,
                },
              }"
            >
              <card-view class="subscription" cardName="Invoice"></card-view>
            </router-link>
          </b-col>
          <b-col
            ><router-link
              :to="{
                name: 'Wallet Statement',
                params: {
                  id: partnerAllData._id,
                  parentId: partnerAllData.officeHierarchy,
                },
              }"
            >
              <card-view class="subscription" cardName="Statement"></card-view>
            </router-link>
          </b-col>
        </b-row>
        <b-row class="mx-1">
          <b-col>
            <router-link
              :to="{
                name: 'User Management',
                params: {
                  id: partnerAllData._id,
                  parentId: partnerAllData.officeHierarchy,
                },
              }"
            >
              <card-view class="subscription" cardName="Users"></card-view>
            </router-link>
          </b-col>
          <b-col>
            <router-link
              :to="{
                name: 'Item',
                params: {
                  id: partnerAllData._id,
                  parentId: partnerAllData.officeHierarchy,
                },
              }"
            >
              <card-view class="subscription" cardName="Items"></card-view>
            </router-link>
          </b-col>
          <b-col>
            <router-link
              :to="{
                name: 'Advertisement',
                params: {
                  id: partnerAllData._id,
                  parentId: partnerAllData.officeHierarchy,
                },
              }"
            >
              <card-view
                class="subscription"
                v-if="userLoggedIn == 'Tenant'"
                cardName="Advertisement"
              ></card-view>
            </router-link>
          </b-col>
        </b-row>

        <b-row class="mx-1">
          <b-col>
            <router-link
              :to="{
                name: 'View Commission',
                params: {
                  id: partnerAllData._id,
                  parentId: partnerAllData.officeHierarchy,
                },
              }"
            >
              <card-view
                class="subscription"
                cardName="View Commission"
              ></card-view>
            </router-link>
          </b-col>
          <b-col>
            <router-link
              :to="{
                name: 'Delivery Preference',
                params: {
                  id: partnerAllData._id,
                  parentId: partnerAllData.officeHierarchy,
                },
              }"
            >
              <card-view
                class="subscription"
                cardName="Delivery Preference"
              ></card-view>
            </router-link>
          </b-col>
          <b-col>
            <router-link
              :to="{
                name: 'Promotion Preference',
                params: {
                  id: partnerAllData._id,
                  parentId: partnerAllData.officeHierarchy,
                },
              }"
            >
              <card-view
                class="subscription"
                cardName="Promotion Preference"
              ></card-view>
            </router-link>
          </b-col>
        </b-row>

        <b-row class="mx-1">
          <b-col
            ><card-view
              cardPath="/inventory"
              v-if="userLoggedIn != 'Tenant'"
              cardName="Inventory"
            ></card-view>
          </b-col>
          <b-col>
            <card-view
              v-if="userLoggedIn != 'Tenant'"
              cardName="Stock Point"
            ></card-view> </b-col
        ></b-row>
      </b-card>
    </div>
  </div>
</template>
<script>
import orgView from "@/components/Partner/PartnerView/Organization";
import billView from "@/components/Partner/PartnerView/BillTO";
import loader from "@/components/loader/nipigeloader.vue";
import agreementView from "@/components/Partner/PartnerView/Agreement";
import credentialView from "@/components/Partner/PartnerView/Credential";
import cardView from "@/components/Partner/PartnerView/CardView";
import { Switch as cSwitch } from "@/components/Switch";
import { mapGetters, mapActions } from "vuex";
import currentUserMix from "@/mixins/currentUser";
import { getReverseGeoCode } from "@/services/geocode";
import ebSelect from "@/components/FormElements/Select";
export default {
  name: "viewPartner",
  mixins: [currentUserMix],
  data() {
    return {
      userLoggedIn: "",
      catalogDomainList: "",
      loading: false,
      //accountStatus:false,
      selectedStatus: "ACTIVE",
    };
  },
  components: {
    orgView,
    billView,
    agreementView,
    credentialView,
    cardView,
    loader,
    ebSelect,
    cSwitch,
  },
  computed: {
    ...mapGetters({
      partnerAllData: "partner/GetPartnerData",
      getCategoryList: "catalog/GetCategoryList",
    }),
    categoryTypeData() {
      if (this.partnerAllData.agreement.marketSegment.length > 0) {
        return this.partnerAllData.agreement.marketSegment[0].categoryType;
      } else {
        return null;
      }
    },
    partnerRoute() {
      if (this.partnerAllData.officeHierarchy !== null) {
        return {
          name: "ChildPartnerList",
          params: {
            id: this.partnerAllData._id,
            parentId: this.partnerAllData.officeHierarchy,
          },
        };
      } else {
        return { name: "PartnerList" };
      }
    },
  },
  methods: {
    ...mapActions({
      Getchildpartnerlist: "partner/fetchChildPartnersList",
    }),
    changeStatus() {
      this.partnerStatusUpdate();
    },
    async offlinePartner(event) {
      try {
        await this.$store.dispatch("partner/offlinePartner", {
          id: this.partnerAllData._id,
          data: {
            isOffline: !this.partnerAllData.isOffline,
          },
        });
        this.$store.commit("partner/setEditedPartnerData", {
          ...this.partnerAllData,
          isOffline: !this.partnerAllData.isOffline,
        });
      } catch (err) {
        // failed
      }
    },
    async deletepartner(data) {
      this.$swal({
        title: "Delete this Partner?",
        text: "Are you sure? You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!",
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("partner/deletePartner", data._id)
            .then(result => {
              this.$toasted.success("Partner Deleted Successfully");
              this.getPartnerListData();
            })
            .catch(error => {
              this.$toasted.error(error.message);
            });
        }
        this.$router.push("/partner");
      });
    },
    async partnerStatusUpdate() {
      try {
        await this.$store.dispatch("partner/partnerStatusUpdate", {
          id: this.partnerAllData._id,
          data: {
            status: this.selectedStatus,
          },
        });
        this.$store.commit("partner/setEditedPartnerData", {
          ...this.partnerAllData,
          isOffline: this.selectedStatus !== "ACTIVE",
          status: this.selectedStatus,
        });
      } catch (err) {}
    },
  },
  async mounted() {
    this.loading = true;
    this.$store.dispatch("partner/fetchPartnerDetails", this.$route.params.id);
    this.selectedStatus = await this.partnerAllData.status;
    this.userLoggedIn = sessionStorage.getItem("userRole");
    this.catalogDomainList = this.$currentUserData.catalogInfo;
    this.loading = false;
  },
};
</script>
<style lang="scss">
.text-style {
  font-family: "Lato";
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
  /* or 138% */

  letter-spacing: 0.15px;

  color: rgba(143, 143, 143, 0.87);
}

.container-fluid {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  /* background-color: #e5e5e5; */
}

.col-12 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 98%;
  flex: 0 0 98%;
  max-width: 98%;
  /* background-color: #e5e5e5; */
}

.view-header-class {
  font-family: "Lato";
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;
  /* identical to box height */

  text-transform: capitalize;

  color: #000000;
}

.collapse-btn {
  color: #2c8ef8;
  text-align: left;
  font-size: 17px;
  padding: 15px;
  font-weight: 600;
  background-color: white;
  border: none;

  &:before {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-bottom: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 6px solid #000000;
    right: 20px;
    top: 25px;
    transition: all 0.3s ease;
  }

  &[aria-expanded="true"] {
    &:before {
      border-top: 0;
      border-bottom: 6px solid black;
      transition: all 0.3s ease;
    }
  }

  &:hover {
    text-decoration: none;
    transition: all 0.3s ease;
    background-color: #fafbfe;
  }
}

@media (max-width: 769px) {
  .subscription {
    width: 250px;
  }
}

// @media (min-width: 770px) {
//   .subscription {
//     display: none;
//   }
// }
</style>
